import {gql} from '@apollo/client';
import {CAR_DETAIL_FRAGMENT} from "../../common/graphqlQueries/fragments";
import {TICKET_JOB_LIST_FRAGMENT} from "../TicketDetailScreen/query";

export const GET_TICKET_LISTING = gql`
    query getTicketListing($page: Int, $search: String){
        getTicketListing(page: $page, search: $search){
            data {
                id
                objectId
                ticketStatus
                domain
                phone
                body
                createdAt
                car {
                    ...CarDetail
                }
                refurbCar{
                    id
                    slug
                    jobList{
                        id
                        status
                    }
                }
                body
            }
            paginator{
                totalItems
                perPage
                numPages
                currentPage
            }
        }
    }
    ${CAR_DETAIL_FRAGMENT}
`;

export const GET_WHATSAPP_CONVERSATION = gql`
    query getConversation($contactNumber: String, $before: String, $last: Int){
        getMessages(contactNumber: $contactNumber, before: $before, last: $last) {
            pageInfo{
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges{
                node{
                    pk
                    id
                    mobileNumber
                    text
                    type
                    url
                    timeCreate
                    messageId
                    sentTime
                    seenTime
                    messageType
                }
                cursor
            }
        }
    }
`;

export const WHATSAPP_SEND_MESSAGE = gql`
    mutation sendMessage($mobileNumber: String!, $message: String){
        sendMessage(mobileNumber: $mobileNumber, sendType: "FREE_FORM", message: $message) {
            ok
            message
        }
    }
`;

export const MARK_AS_READ = gql`
    mutation markAsRead($messageId: String!){
        markAsRead(messageId: $messageId){
            ok
            message
        }
    }
`;

export const GET_WHATSAPP_PROFILE = gql`
    query getWhatsAppProfile($userName: String!){
        getWhatsappProfile(username: $userName, isRead: false) {
            pageInfo{
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges{
                node{
                    id
                    pk
                    mobileNumber
                    optInStatus
                }
            }
        }
    }
`;

export const GET_WHATSAPP_PROFILE_BY_NUMBER = gql`
    query getWhatsAppProfile($phoneNumber: String!) {
        getWhatsappProfile(mobileNumber: $phoneNumber) {
            edges{
                node{
                    id
                    assignedTo{
                        username
                    }
                }
            }
        }
    }
`;

export const ASSIGN_WHATSAPP_PROFILE_TO_USER = gql`
    mutation assignWhatsappProfileToUser($mobileNumber: String!){
        assignWhatsappProfileToUser(mobileNumber: $mobileNumber){
            message
            profile {
                pk
                assignedTo {
                    id
                    username
                }
            }
        }
    }
`;